import { User } from '../services/authService';

// App context user type (simplified version)
interface AppUser {
  id: string | null;
  email: string | null;
  displayName: string | null;
  firstName?: string | null;
  lastName?: string | null;
  role?: 'PATIENT' | 'CAREGIVER' | 'ADMIN' | null;
}

/**
 * Get the appropriate dashboard route based on user role
 */
export const getDashboardRoute = (user: User | AppUser | null): string => {
  if (!user || !user.role) {
    return '/';
  }

  switch (user.role) {
    case 'PATIENT':
      return '/patient-dashboard';
    case 'CAREGIVER':
      return '/caregiver-dashboard';
    case 'ADMIN':
      return '/caregiver-dashboard'; // Admins use caregiver dashboard
    default:
      return '/';
  }
};

/**
 * Get the appropriate redirect route after login
 */
export const getLoginRedirectRoute = (user: User | null, redirectUrl?: string | null): string => {
  // If there's a redirect URL and it's not the auth page, use it
  if (redirectUrl && redirectUrl !== '/auth' && redirectUrl !== '/') {
    return redirectUrl;
  }

  // Otherwise, redirect to the appropriate dashboard
  return getDashboardRoute(user);
};
